export default __webpack_public_path__ + "static/media/success.4bf41516.svg";